import { Component } from '@angular/core';
import { environment } from '../../environments/environment';

@Component({
    selector: 'ez-iovation',
    template: '',
})
export class IovationComponent {

    constructor() {
        this.loadIovationScript();
    }

    private loadIovationScript() {
        let foundScript = false;
        let scripts = document.getElementsByTagName('script');

        for (let i = 0; i < scripts.length; ++i) {
            if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes('snare.js')) {
                foundScript = true;
            }
        }

        if (foundScript === false) {
            // add global vars
            let windowRef: any = window;
            windowRef.io_operation = 'ioBegin';
            windowRef.io_bbout_element_id = 'ioBB';
            windowRef.io_install_stm = false;
            windowRef.io_exclude_stm = 12;
            windowRef.io_install_flash = false;
            windowRef.io_flash_needs_update_handler = '';
            windowRef.io_max_wait = 5000;

            let node = document.createElement('script');
            node.src = environment.iovation.snarejs;
            node.type = 'text/javascript';
            node.async = false;
            node.charset = 'utf-8';

            document.getElementsByTagName('head')[0].appendChild(node);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/iovation.component.ts